import OrganizationForm from "../Forms/OrganizationForm";
import Section from "../Section";

const RegisterOrganization = () => {
  return (
    <Section span={8}>
      <OrganizationForm />
    </Section>
  );
};

export default RegisterOrganization;
